<div class="layout pop-resource-picker"
     [class.disabled]="disabled">
  <mat-select [disabled]="disabled"
              class="pop-mat-select"
              (openedChange)="resetQueryManagers()"
              disableOptionCentering="true"
              disableRipple="true"
              [(value)]="selectedResourceCode">
    <div class="resource-search-container pop-inputs">
      <i class="far fa-search"></i>
      <input [(ngModel)]="searchText"
             type="text"
             (keyup)="queryManagers()" />
    </div>
    <div class="resource-picker-panel">
      <mat-option [value]=""> </mat-option>
      <mat-option *ngFor="let resource of filteredResources"
                  [value]="resource.code"
                  id="resource.code">
        {{ resource.name }}
      </mat-option>
    </div>
  </mat-select>

  <i class="fas fa-exclamation-triangle"
     *ngIf="!selectedResourceCode && !disabled"
     [matTooltip]="'ERROR.RESP_REQUIRED' | translate"
     matTooltipClass="warning-tooltip"></i>
</div>
